export const USER_LOGGED_IN_DETAILS = "USER_LOGGED_IN_DETAILS";
export const SIDEBAR_SCROLL_POSITION = "SIDEBAR_SCROLL_POSITION";
export const ACTIVE_SIDEBAR_MENU = "ACTIVE_SIDEBAR_MENU";
export const SETTINGS = "SETTINGS";
export const ACTIVE_SITE_DETAIL_TAB = "ACTIVE_SITE_DETAIL_TAB";
export const ACTIVE_LEAVE_REQUESTS_TAB = "ACTIVE_LEAVE_REQUESTS_TAB";
export const ACTIVE_AR_REQUESTS_TAB = "ACTIVE_AR_REQUESTS_TAB";
export const ACTIVE_OD_REQUESTS_TAB = "ACTIVE_OD_REQUESTS_TAB";
export const ACTIVE_EMP_ONBOARD_TAB = "ACTIVE_EMP_ONBOARD_TAB";
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT';
export const ACTIVE_PURCHASE_TAB = 'ACTIVE_PURCHASE_TAB';
export const ACTIVE_PURCHASE_REQUEST_TAB = 'ACTIVE_PURCHASE_REQUEST_TAB';
export const ACTIVE_PURCHASE_ORDER_TAB = 'ACTIVE_PURCHASE_ORDER_TAB';
export const ACTIVE_PT_AGAINST_PO_TAB = 'ACTIVE_PT_AGAINST_PO_TAB';
export const ACTIVE_PT_GENERAL_TAB = 'ACTIVE_PT_GENERAL_TAB';
export const ACTIVE_PT_REIMB_TAB = 'ACTIVE_PT_REIMB_TAB';
export const ACTIVE_PAYMENT_ADVISORY_TAB = 'ACTIVE_PAYMENT_ADVISORY_TAB';
export const ACTIVE_GRN_TAB = 'ACTIVE_GRN_TAB';
export const ACTIVE_SALARY_HEAD_TAB = 'ACTIVE_SALARY_HEAD_TAB';
export const ACTIVE_PAYMENT_OVERVIEW_TAB = "ACTIVE_PAYMENT_OVERVIEW_TAB"
export const ACTIVE_STOCK_OUT_TAB = 'ACTIVE_STOCK_OUT_TAB';
export const ACTIVE_ATTENDANCE_SUMMARY_TAB = 'ACTIVE_ATTENDANCE_SUMMARY_TAB';
export const UPDATE_FILTERS_STATES = "ALL_FILTERS"
export const UPDATE_DATE_FILTERS = "UPDATE_DATE_FILTER"

